import { OuiValidationError } from 'omnium-ui/form-field';

export function sirenErrors(): OuiValidationError[] {
  return [
    { code: 'minlength', message: 'Le SIREN doit faire 9 chiffres (trop court)' },
    { code: 'maxlength', message: 'Le SIREN doit faire 9 chiffres (trop long)' },
  ];
}
